/* eslint-disable react/prop-types */
import React from "react";

// The loader of a screen waiting for its data (tables, pages, cards). It is the app's one loader: index.js sets
// antd's Spin to it (so every table's loading and every <Spin /> show it), and screens without a Spin use
// <ScreenLoader />. To change how loading looks everywhere, change it here and in .screen-loader (custom.css).
// Not for buttons or popups: those keep their own small spinners.
export const LoaderIcon = ({ className = "" }) => (
    <span className={`screen-loader ${className}`} role="status" aria-label="Loading">
        <span className="whirly-loader" />
    </span>
);

// Centered in the area a screen's data will fill
const ScreenLoader = ({ minHeight = 300 }) => (
    <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight }}>
        <LoaderIcon />
    </div>
);

export default ScreenLoader;
